import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useCallback } from 'react';
import PaymentService, { ShippingMethod } from 'services/api/PaymentService';
import useRequest from 'hooks/useRequest';

import commonStyles from 'styles/common.module.scss';

interface ShippingMethodSectionProps {
  onChange: (value: string) => void;
  value: string;
}

const ShippingMethodSection: React.FunctionComponent<ShippingMethodSectionProps> = ({ onChange, value }) => {
  const { data: shippingMethods } = useRequest<ShippingMethod[]>(PaymentService.getShippingMethods);

  const handleQuantitySelectChange = useCallback(
    (onChange) => (e: SelectChangeEvent) => {
      onChange(e.target.value);
    },
    []
  );

  return (
    <>
      <h3 className={commonStyles.subTitle}>{'Select Shipping Method'}</h3>
      <FormControl fullWidth>
        <InputLabel id={`shipping-method-select-label`}>Shipping Method</InputLabel>
        <Select
          labelId={`shipping-method-select-label`}
          value={`${value}`}
          label="Shipping Method"
          onChange={handleQuantitySelectChange(onChange)}
        >
          {shippingMethods?.map(({ id, name }, index) => (
            <MenuItem key={`quanity-option-${id}-${index}`} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
export default ShippingMethodSection;
